/**
 * @description
 */

import './sectionNumberResultList.scss';

import React, { Component } from 'react';
import { ISurveySectionInfo, ISectionOptionResultInfo } from '@umu/umu-types';
import FormNumberResultList from '../@formNumberResultList/formNumberResultList';

interface IProps {
    sectionInfo: ISurveySectionInfo;
}

export default class SectionNumberResultList extends Component<IProps> {
    public render() {
        const { resultList } = this.props.sectionInfo;
        return (
            <div className="section-item-result-body">
                <FormNumberResultList resultList={resultList as ISectionOptionResultInfo[]} />
            </div>
        );
    }

    public renderMoreAction() {
        return null;
    }

    public renderMorePanel() {
        return null;
    }
}
